import axios from "axios";

//const
const VERIFY_ENTERPRISE_AUTH_STORE_DATA = "verifyEnterpriseList/VERIFY_ENTERPRISE_AUTH_STORE_DATA";
const VERIFY_ENTERPRISE_AUTH_UPDATE_DATA = "verifyEnterpriseList/VERIFY_ENTERPRISE_AUTH_UPDATE_DATA";
const VERIFY_ENTERPRISE_AUTH_STORE_SELECT_DATA = "verifyEnterpriseList/VERIFY_ENTERPRISE_AUTH_STORE_SELECT_DATA"
//reducer
export const verifyEnterpriseAuth = (state = {
  showEnterpriseAppAuth: [],
  selectedEnterpriseApp: "",
  inputEnterpriseName: "",
  selectedAuths: [],
  selectedAllAuth: [],
  selectedRowKeys:[],
  selectedEnterpriseRowKeys:[],
}, action) => {
  switch (action.type) {
    case VERIFY_ENTERPRISE_AUTH_STORE_DATA:
      return {
        ...state,
        showEnterpriseAppAuth: action.data.map(auth => {
          auth.key = auth.enterpriseName + auth.appCode;
          return auth;
        })
      };
    case VERIFY_ENTERPRISE_AUTH_STORE_SELECT_DATA:
      return {
        ...state,
        selectedEnterpriseApp: action.data,
        selectedAllAuth: action.data ? action.data.authList : [],
      };
    case VERIFY_ENTERPRISE_AUTH_UPDATE_DATA:
      return {
        ...state,
        [action.data.name]: action.data.value
      };
    default:
      return state
  }
};

/**
 * store all enterpriseAppAuths
 */
export const storeEnterpriseAppAuths = (data) => {
  return {
    type: VERIFY_ENTERPRISE_AUTH_STORE_DATA,
    data: data
  }
};

export const storeSelectEnterpriseAppAuths = (data) => {
  return {
    type: VERIFY_ENTERPRISE_AUTH_STORE_SELECT_DATA,
    data: data
  }
};

export const updateData = (data) => {
  return {
    type: VERIFY_ENTERPRISE_AUTH_UPDATE_DATA,
    data: data
  }
};

export const getEnterpriseAppAuths = (data) => (dispatch) => {
  let url = "/api-user/pendingAuths?enterpriseName=" + data;
  axios.get(url, {contentType: "application/json"}).then(
    response => {
      if (response.data) {
        console.log(response.data);
        console.log(response.data[0]);
        dispatch(storeEnterpriseAppAuths(response.data));
        dispatch(storeSelectEnterpriseAppAuths(response.data[0]));
      }
    }
  )
}
